import request from '@/utils/request'

// 获取每日业绩列表
export function dailyPerformanceGetList(data) {
  return request({
    url: '/admin/Daily_performance/getList',
    method: 'post',
    params: data
  })
}

// 导出每日业绩
export function dailyPerformanceExport(data) {
  return request({
    url: '/admin/Daily_performance/export',
    method: 'get',
    params: data,
    responseType: 'blob'
  })
}
 


// WEBPACK FOOTER //
// ./src/api/dailyPerformance.js